import SettingsApp from '@octopus-settings/App';
import Styled from './SettingsPage.styled';

function SettingsPage() {
  return (
    <Styled.Shell>
      <SettingsApp />
    </Styled.Shell>
  );
}

export default SettingsPage;
